import React, { useState } from "react";
import { Box, Typography, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { ReactComponent as DotsIcon } from '../../img/DotsIcon.svg'
import { colors } from '../../Theme/tokens';
import moment from "moment";
import { retrievePriorityIcon } from "../../components/Notifications/PriorityIconText";

const NotificationItem = ({
  notification,
  index,
  apiLoader,
  rowStyle,
  titleStyle,
  bodyStyle,
  menuStyle,
  onRowClick,
  onArchive,
  onDelete,
  checkIsArchived,
  notificationIcons,
  general,
  setSelectedNotification,
  setSelectedId,
  handleResend,
  deleteModal
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const PriorityIcon = retrievePriorityIcon(Number(notification?.isPriority))

  const handleMenuOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setSelectedNotification(notification)
    setSelectedId(notification?.notificationId)
  };

  const handleClose = (e) => {
    e?.stopPropagation();
    setAnchorEl(null);
  };

    const IconContainer = (mainCategoryId) => {
        
        const Icon = notificationIcons[mainCategoryId.mainCategoryId];
        return(
            <Box sx={{width:"36px", height:"36px", minWidth:"36px", minHeight:"36px", backgroundColor: colors.background.iconBox, borderRadius:"7.58px", display:"flex", justifyContent:"center", alignItems:"center" }}>
                {Icon ? <Icon /> : general}
            </Box>
        )
    }

  return (
<Box
  key={index}
  onClick={() => onRowClick(notification)}
  sx={{ ...rowStyle(notification), boxShadow: `0px 1px 5px 0px ${colors.border.card}` }}
>
  {/* Left */}
  <Box sx={{ display: "flex", gap: 2, flex: 1, minWidth: 0 }}>  {/* 👈 flex: 1, minWidth: 0 */}
    <IconContainer mainCategoryId={notification?.mainCategoryId} />

    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0, flex: 1 }}> {/* 👈 minWidth: 0, flex: 1 */}

      {/* Title + Archived chip on the same line */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "nowrap", minWidth: 0 }}> {/* 👈 nowrap so chip doesn't get pushed down */}
        <Typography
          sx={{
            ...titleStyle,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: 0,
            flexShrink: 1, 
          }}
        >
          {notification?.title}
        </Typography>

        {checkIsArchived(notification) && (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: "8px",
              py: "2px",
              borderRadius: "20px",
              border: `1px solid ${colors.border.light}`,
              backgroundColor: colors.background.elevated,
              flexShrink: 0,  // 👈 chip never shrinks/wraps
            }}
          >
            <Typography
              sx={{
                
                fontSize: "10px",
                fontWeight: 600,
                color: colors.text.secondary,
                letterSpacing: "0.5px",
                whiteSpace: "nowrap",
              }}
            >
              Archived
            </Typography>
          </Box>
        )}
      </Box>

      {/* Body stays below */}
      <Typography
        sx={{
          ...bodyStyle,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {notification?.body}
      </Typography>
      {notification?.isPriority && <Typography sx={{fontSize:"12px", fontWeight:500, lineHeight:"140%",color: colors.error.secondary, letterSpacing:"0%",}}>High Priority</Typography>}

    </Box>
  </Box>

      {/* Right */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "space-between",
          gap: 1,
          flexShrink: 0,
          height: "100%",
        }}
      >
        {/* Top row: Failed/Resend, Read check, Dots menu */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* {PriorityIcon  && <PriorityIcon />} */}
          {/* {notification?.userNotificationStatuses[0]?.status?.toLowerCase() === "failed" && (
            <Typography
              onClick={(e) => { e.stopPropagation(); handleResend(notification); }}
              sx={{
                
                fontSize: "12px",
                color: colors.error.main,
                fontWeight: "600",
                cursor: "pointer",
                whiteSpace: "nowrap",
                textDecoration: "underline" ,
              }}
            >
              Resend
            </Typography>
          )} */}
          {notification?.userNotificationStatuses[0]?.status == "READ" && (
            <CheckIcon sx={{ color: colors.secondary.dark, fontSize: "16px" }} titleAccess="Read" />
          )}
          <Box>
            {/* Date below — relative time on mobile, full format on desktop */}
            <Typography
              sx={{
                ...bodyStyle,
                fontSize: isMobile ? "10px" : "11px",
                whiteSpace: "nowrap",
                textAlign: "right",
                color: colors.secondary.dark
              }}
            >
              {moment(notification?.createdAt).fromNow()}
            </Typography>
            <Box sx={{display:"flex", justifyContent:"flex-end",}}>
              <IconButton disabled={apiLoader} onClick={handleMenuOpen}>
                <DotsIcon />
              </IconButton>
            </Box>  
          </Box>
        </Box>

      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        slotProps={{ paper: { sx: menuStyle } }}
      >
        <MenuItem
          onClick={(e) => {
            handleClose(e);
            onArchive(notification);
          }}
        >
          {checkIsArchived(notification) ? "Unarchive" : "Archive"}
        </MenuItem>

        {checkIsArchived(notification) && <MenuItem
          onClick={(e) => {
            handleClose(e);
            onDelete(notification?.notificationId);
          }}
          sx={{color: colors.error.secondary}}
        >
          Delete
        </MenuItem>}
      </Menu>
    </Box>
  );
};

export default NotificationItem;